import * as React from "react";
import { Component } from "react";
import styles from "../../../styles/flyouts/superadmin/boq_supply_type_groups/Properties.scss";
import * as _ from "lodash";
import { withRouter } from "react-router";
import autobind from "autobind-decorator";
import {__, validateForm} from "../../../core/utils";
import { setNotification } from "../../../redux/actions/general/notification";
import { listBoqSupplyTypeGroups, updateBoqSupplyTypeGroup } from "../../../redux/actions/table/superadmin/boq_supply_type_groups";
import EditBOQSupplyTypeGroupForm from "../../../forms/superadmin/boq_supply_type_groups/EditBOQSupplyTypeGroupForm";

@withRouter
class Properties extends Component {
    @autobind
    _handleSubmit(formData) {
        return validateForm(
            updateBoqSupplyTypeGroup(formData.id, _.omit(formData, ['id'])).then(() => {
                listBoqSupplyTypeGroups();

                this.props.readAction(formData.id);

                setNotification(__('properties.notifications.properties-have-been-saved'));
            })
        );
    }

    render() {
        const { data } = this.props;

        return (
            <div className={styles.scroller}>
                <EditBOQSupplyTypeGroupForm
                    onSubmit={this._handleSubmit}
                    initialValues={{
                        ..._.pick(data, ['id', 'name']),
                    }}
                />
            </div>
        );
    }
}

export default Properties;
